import React from "react";

export const OneBagNotice: React.FC<{ onKeepShoppingClick: () => void }> = ({
  onKeepShoppingClick,
}) => (
  <div className="text-xs mt-lg">
    You may have one bag going at a time. Select{" "}
    <button onClick={onKeepShoppingClick} className="text-green cursor-pointer">
      keep shopping
    </button>{" "}
    to add more items from same dispensary.
  </div>
);
